import { MemberCard } from "@/components/entities/MemberCard";

export function MemberList({ members, isViewerAdmin, onRemove, actionInProgress }) {
  return (
    <div className="space-y-2">
      {members.map((member) => {
        const uid = String(member.userId);
        return (
          <MemberCard
            key={uid}
            member={member}
            isViewerAdmin={isViewerAdmin}
            onRemove={onRemove}
            busy={actionInProgress?.startsWith(uid)}
          />
        );
      })}
    </div>
  );
}
